<template>
  <table id="upgrades">
    <tr>
      <th>Name</th>
      <th>Cps</th>
      <th>Starting price</th>
      <th>Qty</th>
      <th>Total Cps</th>
      <th>Next price</th>
      <th>Price per Cps</th>
      <th>Actions</th>
    </tr>
    <tr
      v-for="(upgrade, index) in upgrades"
      :key="upgrade.name"
      v-bind:class="{ nextupgrade: index === nextUpgradeIndex }"
    >
      <td class="name">{{ upgrade.name }}</td>
      <td class="number">{{ thousandSeparator(upgrade.cps) }}</td>
      <td class="number">{{ thousandSeparator(upgrade.startingPrice) }}</td>
      <td class="number">
        <input
          :tabindex="index + 1"
          type="text"
          v-model.number="upgrade.qty"
          class="qty-input"
        />
      </td>
      <td class="number">
        {{ thousandSeparator((upgrade.cps * upgrade.qty).toFixed(1)) }}
      </td>
      <td class="number">{{ thousandSeparator(nextPrice(upgrade)) }}</td>
      <td class="number">
        {{ thousandSeparator((nextPrice(upgrade) / upgrade.cps).toFixed(2)) }}
      </td>
      <td class="actions">
        <Button
          class="action-button"
          v-on:button-clicked="add(index)"
          text="+"
        />
        <Button
          class="action-button"
          v-on:button-clicked="minus(index)"
          text="-"
        />
      </td>
    </tr>
    <tr>
      <td colspan="5" class="number">
        {{ thousandSeparator(totalQty().toFixed(2)) }}
      </td>
    </tr>
  </table>
</template>

<script>
import Button from "./Button";

export default {
  name: "UpgradeList",
  components: {
    Button
  },
  props: {
    upgrades: Array,
    nextUpgradeIndex: Number
  },
  methods: {
    nextPrice: function(upgrade) {
      return this.$parent.getNextPrice(upgrade);
    },

    thousandSeparator: function(number) {
      return this.$parent.thousandSeparator(number);
    },

    totalQty: function() {
      return this.upgrades.reduce(
        (acc, upgrade) => acc + upgrade.cps * upgrade.qty,
        0
      );
    },

    add: function(index) {
      this.upgrades[index].qty += 1;
    },

    minus: function(index) {
      this.upgrades[index].qty -= 1;
    }
  }
};
</script>

<style scoped>
.name {
  text-align: left;
}

.number {
  text-align: right;
}

.qty-input {
  text-align: right;
  width: 50px;
}

.actions button:not(:first-child) {
  margin-left: 5px;
}

#upgrades {
  border-collapse: collapse;
  margin-left: auto;
  margin-right: auto;
}

#upgrades td,
#upgrades th {
  border: 1px solid #ddd;
  padding: 8px;
}

#upgrades tr:nth-child(even) {
  background-color: #f2f2f2;
}

#upgrades tr:hover {
  background: #ddd;
}

#upgrades th {
  background: royalblue;
  color: white;
  padding-top: 12px;
  padding-bottom: 12px;
}

#upgrades tr.nextupgrade {
  background-color: royalblue;
  color: white;
}

#upgrades tr.nextupgrade .action-button {
  background-color: white;
  color: royalblue;
}

#upgrades tr.nextupgrade .action-button:hover {
  background-color: #ddd;
}
</style>
